<script lang="ts">
  import { inview } from 'svelte-inview';

  import { is } from '@shared/utils';

  import LogoIconDO from './LogoIconDO.svelte';
  import LogoTextDO from './LogoTextDO.svelte';
  import { iconDOTriggers, textDOTriggers } from '../models';
  import type { LottieUID } from '../types';

  export let textFill: 'black' | 'white' = 'white';

  export let iconUID: LottieUID;
  export let textUID: LottieUID;

  const GAP = 6;
  const WIDTH = 166;
  const LOGO_WIDTH = 44;
  const TEXT_WIDTH = 116;

  export let width = WIDTH;
  $: gap = width * (GAP / WIDTH);
  $: logoWidth = (width - gap) * (LOGO_WIDTH / (WIDTH - GAP));
  $: textWidth = (width - gap) * (TEXT_WIDTH / (WIDTH - GAP));

  const options = {
    threshold: 0.1,
  };
</script>

<div
  class="flex"
  on:mouseenter="{() => iconDOTriggers.loopTrigger(iconUID)}"
  on:mouseleave="{() => iconDOTriggers.endLoopTrigger(iconUID)}"
  use:inview="{options}"
  on:inview_enter="{() => textDOTriggers.appearTrigger(textUID)}"
  role="img"
>
  <div style="margin-right: {gap}px">
    <LogoIconDO width="{logoWidth}" uid="{iconUID}" />
  </div>

  <div class="{is(textFill === 'black', 'invert')}">
    <LogoTextDO width="{textWidth}" uid="{textUID}" />
  </div>
</div>
